module.exports = __webpack_public_path__ + "static/media/Mia,23@2x.d0cbd9e3.png";